<template>
  <v-card>
    <v-card-title v-if="options.title">
      <span class="headline">{{ options.title }}</span>
      <v-spacer></v-spacer>
      <v-chip color="info" small>Docenti selezionati: {{ form.assigned.length }}</v-chip>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text>
        <v-container>
          <v-row
            class="mb-12"
            no-gutters
          >

          <v-col
              cols="12"
            >
            <ValidationObserver
              ref="form"
              tag="form"
              @submit.prevent="addToList"
            >
            <v-card
              class="mt-5"
            >
              <v-card-text>

            <Search
              v-model="filters.search"
              :label="$t('SEARCH')"
              prepend-icon="search"
              :delay="500"
            />
            <ValidationProvider
              rules="required"
              vid="book_id"
              :name="$t('fields.book').toLowerCase()"
              v-slot="{ errors }"
            >

              <v-data-table
                v-model="form.bookSelected"
                :single-select="false"
                :headers="headers"
                :items="books"
                show-select
                item-key="id"
                :server-items-length="totalItems"
                :no-data-text="$t('NO_DATA')"
                :no-results-text="$t('NO_DATA')"
                hide-default-footer
                :options.sync="pagination"
                :loading="loadingBook"
                class="elevation-1"
              >
                <template v-slot:item.qty="{ item }">
                     {{ getQuantity(item.warehouses) }}
                </template>
              </v-data-table>
              <div class="text-xs-center pt-2">
                  <Paginator
                    :total-items="totalItems"
                    :page.sync="pagination.page"
                    :items-per-page.sync="pagination.itemsPerPage"
                    @change="fetchBooks"
                  />
              </div>

            </ValidationProvider>

            <ValidationProvider
                rules="required"
                :name="$t('fields.book_type').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-select
                :items="bookType"
                v-model="form.book_type"
                item-text="name"
                item-value="id"
                :label="$t('fields.book_type')"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>

            <ValidationProvider
                rules="required"
                :name="$t('fields.type_shipping').toLowerCase()"
                v-slot="{ errors }"
            >
              <v-select
                :items="shippingType"
                v-model="form.shipping_type_id"
                item-text="name"
                item-value="id"
                :label="$t('fields.type_shipping')"
                :error-messages="errors"
              >
              </v-select>
            </ValidationProvider>


            </v-card-text>
            </v-card>
            </ValidationObserver>
            </v-col>

            <v-col
              cols=12
              class="mt-5"
              v-if="form.bookSelected.length"
            >
              <v-card>
                <v-card-title>
                  <span class="subtitle-1 font-weight-bold">Libri selezionati ({{ form.bookSelected.length }})</span>
                </v-card-title>
                <v-card-text>
                  <v-chip
                    v-for="book in form.bookSelected"
                    :key="book.id"
                    class="ma-1"
                    close
                    @click:close="removeBook(book)"
                  >
                    {{ book.isbn }} - {{ book.title }}
                  </v-chip>
                </v-card-text>
              </v-card>
            </v-col>

            <v-col
              cols=12
              class="mt-10"
            >
             <v-card
                class="mt-10 mb-10"
              >
                <v-card-actions>

                  <v-btn :disabled="enableSaveBtn" @click="save" color="primary">{{ $t('SAVE') }}</v-btn>
                  <v-btn @click="cancel">{{ $t('CANCEL') }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-col>
          </v-row>
        </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
  import { mapActions, mapState } from 'vuex';

  import { booksService } from '../../../utils/services/books.service';
  import Search from '../../shared/Inputs/Search.vue';
  import Paginator from '../../shared/Paginator';

  import { DeliveryMethods } from '../../../utils/constants/delivery-methods';
  import { BookTypes } from '../../../utils/constants/book-constants';

  export default {
    name: 'CampaignTeacherSubjectModal',
    components: {
      Search,
      Paginator,
    },
    data() {
      return {
        stored: null,
        // editTeacher: 0,
        books: [],
        teachers: [],
        headers: [
          { text: '', value: '' },
          { text: this.$t('fields.isbn'), value: 'isbn' },
          { text: this.$t('fields.author'), value: 'author' },
          { text: this.$t('fields.title'), value: 'title' },
          { text: this.$t('fields.volume'), value: 'volume', sortable: true },
          { text: this.$t('fields.year'), value: 'pubblication_year', sortable: true },
          { text: this.$t('fields.editor'), value: 'editor', sortable: true },
          { text: this.$t('fields.stock'), value: 'qty', sortable: true },
        ],

        book: {},
        shippingType: [],
        bookType: [],
        form: {
          assigned: [],
          shipping_type_id: null,
          book_type: null,
          auto_assignment: true,
          bookSelected: [],
        },
        filters: {
          search: null,
        },
        loading: false,
        saving: false,
        loadingBook: false,
        totalItems: 0,
        pagination: {
          page: 1,
          itemsPerPage: 10,
          sortDesc: [true],
          sortBy: ['title'],
        },
      };
    },
    computed: {
      ...mapState('modal', ['options', 'data']),
      enableAddress() {
        const allowed = [DeliveryMethods.HOME, DeliveryMethods.SCHOOL];
        return allowed.includes(this.formTmp.shipping_type_id);
      },
      enableSaveBtn() {
        return !(this.form.assigned.length) || this.saving;
      },
      requestFilters() {
        const filters = {
          search: this.filters.search,
          in_warehouse: true,
        };
        if (this.pagination.sortBy.length === 1 && this.pagination.sortDesc.length === 1) {
          const { sortBy, sortDesc } = this.pagination;
          filters.sortBy = sortBy;
          filters.sortDesc = sortDesc;
        }
        return filters;
      },
    },
    methods: {
      ...mapActions('alert', ['showToast']),
      ...mapActions('modal', ['hideModal', 'loadingModal']),

      removeBook(book) {
        this.form.bookSelected = this.form.bookSelected.filter(b => b.id !== book.id);
      },
      ...mapActions('confirm', ['showConfirm']),

      getQuantity(warehouses) {
        let str = '';
        warehouses.forEach(warehouse => {
          str += `${warehouse.name}: ${warehouse.pivot.qty}`;
        });
        return (str) || 0;
      },

      getShippingMethods() {
        Object.keys(DeliveryMethods).forEach(method => {
          this.shippingType.push({ id: method, name: this.$t(`delivery_methods.${method}`) });
        });
      },

      getBookTypes() {
        Object.keys(BookTypes).forEach(type => {
          this.bookType.push({ id: type, name: this.$t(`book_types.${type}`) });
        });
      },

      async fetchBooks(forcePage) {
        this.loadingBook = true;
        const { page, itemsPerPage } = this.pagination;
        return booksService.index({
          page: page || forcePage || 1,
          itemsPerPage,
          filters: this.requestFilters,
        })
          .then(response => {
            this.books = response.data.data;
            this.totalItems = response.data.meta.total;
            this.pagination = this.getPagination(
              response.data.meta,
              { oldPagination: this.pagination, forcePage },
            );

            localStorage.setItem('campaign-last-books-search', this.filters.search || '');
          })
          .catch(error => {
            this.handleError(error, this.errors);
          })
          .finally(() => {
            this.loadingBook = false;
          });
      },

      resetForm() {
        // this.formTmp.address = null;
        // this.formTmp.shipping_type_id = null;
        // Wait until the models are updated in the UI
        this.$nextTick(() => {
          this.$refs.formTmp.reset();
        });
      },

      async save() {
        const isValid = this.form.assigned.length;
        if (isValid && !this.saving) {
            if (this.options.onSave) {
              this.saving = true;
              this.loadingModal(true);
              this.options.onSave(
                this.form,
                this.errors,
              )
              .then(() => {
                  this.loadingModal(false);
              })
              .catch(error => {
                  console.log(error);
                  // this.handleError(error, this.errors);
              })
              .finally(() => {
                  this.saving = false;
                  this.loadingModal(false);
              });
            }
        }
      },
      cancel() {
        this.hideModal({});
      },
    },

    async created() {
      this.loadingModal(true);
      this.getBookTypes();
      this.getShippingMethods();
      // Ultima ricerca del titolo, condivisa con la finestra di Propaganda docente
      const lastSearch = localStorage.getItem('campaign-last-books-search');
      if (lastSearch) {
        // il watcher su filters carica i libri già filtrati
        this.filters.search = lastSearch;
      } else {
        this.fetchBooks(1);
      }
      if (this.data.stored.teachers) {
        this.form.assigned = this.data.stored.teachers;
      }
      this.loadingModal(false);
    },
    watch: {
      filters: {
        deep: true,
        handler() {
          this.fetchBooks(1);
        },
      },
      'pagination.sortBy': {
        handler(oldVal, newVal) {
          if (newVal !== oldVal) {
            this.fetchBooks(1);
          }
        },
      },

    },
  };
</script>
<style lang="scss">
  .list-info{
    list-style-type: none;
  }
  .property-list{
    display: flex;
    list-style-type: none;
    li {
      padding-left: 5px;
    }
  }
</style>
